import { motion } from "framer-motion";
import WButton from "../wbutton/WButton";
import { useRouter } from "next/router";
import { useCallback, useState } from "react";
import WModal from "../wmodal/WModal";
import { ReactMarkdown } from "react-markdown/lib/react-markdown";
import clsx from "clsx";
import parse from "html-react-parser";
import fbEvent from "@/utils/fbEvent";

/* eslint-disable-next-line */
export interface LAnimatedCardsSectionProps {
  id?: string;
  topTitle?: string;
  mainTitle: string;
  secondarytitle?: string;
  firstSectionImages: {
    imgageUrl: string;
    altTag: string;
    modalText?: string;
  }[];
  secondSectionImages?: {
    imgageUrl: string;
    altTag: string;
    modalText?: string;
  }[];
  button?: {
    text: string;
    url: string;
  };
}

export function LAnimatedCardsSection(props: LAnimatedCardsSectionProps) {
  const router = useRouter();
  const [modal, setModal] = useState("");
  const [imageModalText, setImageModalText] = useState("");

  const openModalAndSetText = useCallback((text: string) => {
    setModal("image-modal");
    setImageModalText(text);
  }, []);
  return (
    <div className="relative py-20 bg-ekblue" id={props?.id}>
      <div className="container flex flex-col gap-10 px-4 mx-auto lg:max-w-7xl">
        <div className="flex flex-col gap-5 text-center">
          <div className="text-xl font-semibold text-ekgreen">
            {props?.topTitle}
          </div>
          <h1 className="text-white">{parse(props?.mainTitle)}</h1>
          <span className="text-2xl text-white">{props?.secondarytitle}</span>
        </div>
      </div>
      <div className="flex flex-col items-center justify-center space-y-10 overflow-x-scroll lg:overflow-hidden">
        <motion.div
          animate={{ x: [0, -1000, 0] }}
          transition={{ type: "spring", duration: 30, repeat: Infinity }}
          className="flex gap-5 mt-10"
        >
          {props?.firstSectionImages?.map((image, idx) => (
            <div
              key={idx}
              className={clsx([
                image?.modalText && "cursor-pointer",
                "flex-shrink-0 rounded-lg lg:overflow-hidden lg:h-auto",
              ])}
              onClick={() =>
                image?.modalText
                  ? openModalAndSetText(image?.modalText)
                  : undefined
              }
            >
              <img src={image?.imgageUrl} alt={image?.altTag} />
            </div>
          ))}
        </motion.div>

        {props?.secondSectionImages && (
          <motion.div
            animate={{ x: [-1000, 0, -1000] }}
            transition={{ type: "spring", duration: 50, repeat: Infinity }}
            className="flex gap-5 mt-10"
          >
            {props?.secondSectionImages?.map((image, idx) => (
              <div
                key={idx}
                className="flex-shrink-0 overflow-hidden rounded-lg"
              >
                <img src={image?.imgageUrl} alt={image?.altTag} />
              </div>
            ))}
          </motion.div>
        )}
      </div>
      <div className="flex items-center justify-center w-full px-4 mt-10">
        {props?.button && (
          <WButton
            text={props?.button?.text}
            type="primary-red-btn"
            className="mx-auto w-fit lg:mx-0"
            onClick={() => {
              props?.button?.url && router.push(props?.button.url);
              fbEvent("Schedule");
            }}
          />
        )}
      </div>
      {modal === "image-modal" && (
        <WModal setModal={setModal}>
          <ReactMarkdown>{imageModalText}</ReactMarkdown>
        </WModal>
      )}
    </div>
  );
}

export default LAnimatedCardsSection;
